import React from "react";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import styles from "./styles/timeline-current-indicator.css.js";
import { secondsToPixels, CURRENT_INDICATOR_WIDTH } from "./timeline-utils";

const TimelineCurrentIndicator = ({ classes, currentTime, height = 0 }) => (
  <svg
    style={{ transform: `translate(${secondsToPixels(currentTime)}px)` }}
    className={classes.container}
    height="100%"
    width={CURRENT_INDICATOR_WIDTH}
  >
    <polyline
      className={classes.currentIndicator}
      fill="none"
      strokeWidth={CURRENT_INDICATOR_WIDTH}
      points={`0,0 0,${height}`}
    />
  </svg>
);

TimelineCurrentIndicator.propTypes = {
  /*
   * Momento seleccionado
   */
  currentTime: PropTypes.number,
  /*
   * Altura del eje del timeline
   */
  height: PropTypes.number,
};

export default withStyles(styles)(TimelineCurrentIndicator);
